import * as ActionTypes from './constants';
import { cookieTypes, defaultCookieConsentState } from './utils';

export const defaultState = () => ({
  hasSavedCookieSettings: false,
  preferences: defaultCookieConsentState(),
});

export function cookieDashboard(state = defaultState(), action) {
  const { type, payload } = action;

  if (type === ActionTypes.SET_HAS_SAVED_COOKIE_SETTINGS) {
    return {
      ...state,
      hasSavedCookieSettings: true,
    };
  }

  if (type === ActionTypes.SET_AGREE_TO_ALL) {
    const preferences = { ...state.preferences };

    cookieTypes.forEach((cookieType) => {
      preferences[cookieType] = true;
    });

    return {
      ...state,
      preferences,
    };
  }

  if (type === ActionTypes.UPDATE_COOKIE_STATUS) {
    const preferences = { ...state.preferences };

    cookieTypes.forEach((cookieType) => {
      if (Object.hasOwnProperty.call(payload, cookieType)) {
        preferences[cookieType] = payload[cookieType];
      }
    });

    return {
      ...state,
      preferences,
    };
  }

  return state;
}
